import { useFirebaseNotifications } from '../../hooks/useFirebaseNotifications';

export const FirebaseNotificationListener = () => {
  useFirebaseNotifications();
  return null;
};
